<template>
  <div class="focus-industry">
    <div class="row focus-industry-content">
      <div class="focus-industry-content-left">
        <el-button class="add-btn" @click="onAddIndustryClick">添加关注行业</el-button>
        <div class="focus-industry-content-left-table">
          <el-table
            :data="industryData"
            height="calc(100vh - 220px)"
          > 
            <el-table-column
              label="行业"
              >
              <template slot="header" slot-scope="scope">
                <div @onScope="scope">
                  <div class="header-title">行业</div>
                </div>
              </template>
              <template slot-scope="scope">
                <div class="title-name">{{scope.row.name}}</div>
              </template>
            </el-table-column>
            <el-table-column width="76px" label="操作">
              <template slot="header" slot-scope="scope">
                <div @onScope="scope">
                  <div class="header-title">操作</div>
                </div>
              </template>
            <template slot-scope="scope">
              <div class="operation-class">
                <el-tooltip 
                  class="item" 
                  effect="dark" 
                  content="取消关注" 
                  :visible-arrow="false"
                  :enterable="false"
                  popper-class="tip"
                  placement="bottom-start"
                >
                  <i class="delete" @click="onDeleteBtnClick(scope.row)"></i>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          </el-table>
        </div>
        <div class="pager" v-if="industryTotalCount > industryPageSize">
          <el-pagination
            background
            @current-change="industryHandleCurrentChange"
            :current-page.sync="industryPageNum"
            :page-size="industryPageSize"
            layout="prev, pager, next, jumper"
            :total="industryTotalCount">
            </el-pagination>
        </div>
      </div>
      <div class="focus-industry-content-right">
        <el-button class="add-btn" @click="onAddThemeClick">添加关注主题</el-button>
        <div class="focus-industry-content-right-table">
          <el-table
            :data="themeData"
            height="calc(100vh - 220px)"
          > 
            <el-table-column
              label="主题"
              >
              <template slot="header" slot-scope="scope">
                <div @onScope="scope">
                  <div class="header-title">主题</div>
                </div>
              </template>
              <template slot-scope="scope">
                <div class="title-name">{{scope.row.name}}</div>
              </template>
            </el-table-column>
            <el-table-column width="76px" label="操作">
              <template slot="header" slot-scope="scope">
                <div @onScope="scope">
                  <div class="header-title">操作</div>
                </div>
              </template>
            <template slot-scope="scope">
              <div class="operation-class">
                <el-tooltip 
                  class="item" 
                  effect="dark" 
                  content="取消关注" 
                  :visible-arrow="false"
                  :enterable="false"
                  popper-class="tip"
                  placement="bottom-start"
                >
                  <i class="delete" @click="onDeleteThemeBtnClick(scope.row)"></i>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          </el-table>
        </div>
        <div class="pager" v-if="themeTotalCount > themePageSize">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="themePageNum"
            :page-size="themePageSize"
            layout="prev, pager, next, jumper"
            :total="themeTotalCount">
            </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog
      title='取消关注'
      class="delete-dialog"
      :visible.sync="dialogVisible"
      width="400px"
      top="33vh"
    >
    <div class="content">取消关注“{{ industryName }}”？</div>
      <div class="footer" slot="footer" >
        <div class="footer-btn">
          <el-button class="cancel-btn" @click="onCancelClick">取消</el-button>
          <el-button class="confirm-btn" @click="onOKDeleteBtnClick">确定</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title='取消关注'
      class="delete-dialog"
      :visible.sync="themeDialogVisible"
      width="400px"
      top="33vh"
    >
    <div class="content">取消关注“{{ themeName }}”？</div>
      <div class="footer" slot="footer" >
        <div class="footer-btn">
          <el-button class="cancel-btn" @click="onThemeCancelClick">取消</el-button>
          <el-button class="confirm-btn" @click="onOKDeleteThemeBtnClick">确定</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title=''
      class="filter-dialog"
      :visible.sync="addIndustryDialogVisible"
      width="460px"
      top="25vh"
      :show-close=false
    >
    <div v-if="dialogIndustrySelectedTags.length">
      <div class="dialog-selected-title">已关注行业</div>
      <div class="dialog-selected">
         <div class="row selected-tag">
          <div @click="onDelTag(item)" class="row industry-tag" v-for="(item, index) in dialogIndustrySelectedTags" :key="index">
            <div>{{item}}</div>
            <div class="del-img"></div>
          </div>
        </div>
      </div>
    </div>
      <div class="dialog-content">
        <div class="row dialog-detail">
          <div class="dialog-detail-item" :class="{'industry-active': dialogIndustrySelectedTags.indexOf(item.name) > -1}" @click="onSelectIndustryTagClick(item.name)" v-for="(item, index) in industryTags" :key="index">{{item.name}}</div>
        </div>
      </div>
      <div class="dialog-footer">
        <div class="footer">
          <div class="footer-btn">
            <el-button class="cancel-btn" @click="cancelAddIndustryBtnClick">取消</el-button>
            <el-button class="confirm-btn" @click="confirmAddIndustryBtnClick">确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog> 

    <el-dialog
      title=''
      class="theme-filter-dialog"
      :visible.sync="addThemeDialogVisible"
      width="460px"
      top="25vh"
      :show-close=false
    >
      <div v-if="dialogThemeSelectedTags.length">
        <div class="theme-dialog-selected-title">已关注主题</div>
        <div class="theme-dialog-selected">
          <div class="row selected-tag">
            <div @click="onDelThemeTag(item)" class="row industry-tag" v-for="(item, index) in dialogThemeSelectedTags" :key="index">
              <div>{{item}}</div>
              <div class="del-img"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-content">
        <div class="input-container">
          <input 
            ref="input" 
            type="text" 
            :placeholder="'搜索主题'" 
            v-model.trim="searchText" 
            @input="onInputSearch" 
          />
          <el-button class="search-button"><i class="icon-search"></i></el-button>
        </div>
        <div class="row dialog-detail">
          <div class="dialog-detail-item" :class="{'industry-active': dialogThemeSelectedTags.indexOf(item.name) > -1}" @click="onSelectThemeTagClick(item.name)" v-for="(item, index) in themeNewTags" :key="index">{{item.name}}</div>
        </div>
      </div>
      <div class="dialog-footer">
        <div class="footer">
          <div class="footer-btn">
            <el-button class="cancel-btn" @click="cancelAddThemeBtnClick">取消</el-button>
            <el-button class="confirm-btn" @click="confirmAddThemeBtnClick">确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog> 
  </div>  
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';

export default {
  data() {
    return {
      timer: null,
      searchText: '',
      username: '',
      industryTags: [],
      dialogVisible: false,
      addIndustryDialogVisible: false,
      industryName: '',
      industryData: [],
      dialogIndustrySelectedTags: [],
      addThemeDialogVisible: false,
      themeTags: [],
      themeNewTags: [],
      themeData: [],
      dialogThemeSelectedTags: [],
      themePageNum: 1,
      themePageSize: 20,
      themeTotalCount: 0,
      industryPageNum: 1,
      industryPageSize: 20,
      industryTotalCount: 0,
      themeDialogVisible: false,
      themeName: '',
      themeId: 0,
      allIndustryData: [],
      allThemeData: []
    };
  },
  methods: {
    onInputSearch() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.themeNewTags = this.themeTags.filter(item => {
          if (item.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1) {
            return true;
          }
          return null;
        });
      }, 600);
    },
    onAddThemeClick() {
      this.addThemeDialogVisible = true;
      QuestionQuery.getThemeTags().then(res => {
        this.themeTags = res;
        this.allThemeData.forEach(item => {
          this.themeTags.forEach(i => {
            if (item.name === i.name) {
              this.themeTags.splice(this.themeTags.indexOf(i), 1);
            }
          });
        });
        this.themeNewTags = JSON.parse(JSON.stringify(this.themeTags));
      });
    },
    onDeleteBtnClick(res) {
      this.dialogVisible = true;
      this.industryName = res.name;
    },
    onDeleteThemeBtnClick(res) {
      this.themeDialogVisible = true;
      this.themeName = res.name;
      this.themeId = res.id;
    },
    onCancelClick() {
      this.dialogVisible = false;
    },
    onThemeCancelClick() {
      this.themeDialogVisible = false;
    },
    onOKDeleteBtnClick() {
      QuestionQuery.deleteMonitorIndustry(this.username, this.industryName).then(() => {
        this.dialogVisible = false;
        this.industryPageNum = 1;
        this.getMonitorIndustryList();
        this.getAllMonitorIndustryList();
      });
    },
    onOKDeleteThemeBtnClick() {
      QuestionQuery.deleteMonitorTheme(this.themeId).then(() => {
        this.themeDialogVisible = false;
        this.themePageNum = 1;
        this.getMonitorThemeList();
        this.getAllMonitorThemeList();
      });
    },
    onAddIndustryClick() {
      this.addIndustryDialogVisible = true;
      QuestionQuery.getNewsIndustryTags('industry').then(res => {
        this.industryTags = res.industry;
        this.allIndustryData.forEach(item => {
          this.industryTags.forEach(i => {
            if (item.name === i.name) {
              this.industryTags.splice(this.industryTags.indexOf(i), 1);
            }
          });
        });
      });
    },
    cancelAddThemeBtnClick() {
      this.addThemeDialogVisible = false;
    },
    confirmAddThemeBtnClick() {
      QuestionQuery.getAddMonitorTheme(this.username, this.dialogThemeSelectedTags).then(() => {
        this.addThemeDialogVisible = false;
        this.dialogThemeSelectedTags = [];
        this.getMonitorThemeList();
        this.getAllMonitorThemeList();
      });
    },
    cancelAddIndustryBtnClick() {
      this.dialogIndustrySelectedTags = [];
      this.addIndustryDialogVisible = false;
    },
    confirmAddIndustryBtnClick() {
      QuestionQuery.getAddMonitorIndustry(this.username, this.dialogIndustrySelectedTags).then(() => {
        this.addIndustryDialogVisible = false;
        this.dialogIndustrySelectedTags = [];
        this.getMonitorIndustryList();
        this.getAllMonitorIndustryList();
      });
    },
    handleCurrentChange(res) {
      this.themePageNum = res;
      this.getMonitorThemeList();
    },
    industryHandleCurrentChange(res) {
      this.industryPageNum = res;
      this.getMonitorIndustryList();
    },
    getMonitorThemeList() {
      QuestionQuery.getMonitorThemeList(this.username, this.themePageNum, this.themePageSize).then(res => {
        this.themeTotalCount = res.total_count;
        this.themeData = res.page_items.map(item => {
          return {
            name: item.theme,
            id: item.id
          };
        });
      });
    },
    getAllMonitorThemeList() {
      QuestionQuery.getMonitorThemeTagList(this.username).then(res => {
        this.allThemeData = res.map(item => {
          return {
            name: item.theme
          };
        });
      });
    },
    getMonitorIndustryList() {
      QuestionQuery.getMonitorIndustryTagList(this.username, this.industryPageNum, this.industryPageSize).then(res => {
        this.industryTotalCount = res.total_count;
        this.industryData = res.page_items.map(item => {
          return {
            name: item.industry,
            id: item.id
          };
        });
      });
    },
    getAllMonitorIndustryList() {
      QuestionQuery.getMonitorIndustryTag(this.username).then(res => {
        this.allIndustryData = res.industry;
      });
    },
    onSelectThemeTagClick(res) {
      if (this.dialogThemeSelectedTags.indexOf(res) === -1) {
        this.dialogThemeSelectedTags.push(res);
      } else {
        this.dialogThemeSelectedTags.splice(this.dialogThemeSelectedTags.indexOf(res), 1);
      }
    },
    onSelectIndustryTagClick(res) {
      if (this.dialogIndustrySelectedTags.indexOf(res) === -1) {
        this.dialogIndustrySelectedTags.push(res);
      } else {
        this.dialogIndustrySelectedTags.splice(this.dialogIndustrySelectedTags.indexOf(res), 1);
      }
    },
    onDelTag(res) {
      this.dialogIndustrySelectedTags.splice(this.dialogIndustrySelectedTags.indexOf(res), 1);
    },
    onDelThemeTag(res) {
      this.dialogThemeSelectedTags.splice(this.dialogThemeSelectedTags.indexOf(res), 1);
    }
  },
  mounted() {
    this.username = authService.getLoggedUserName();
    this.getMonitorIndustryList();
    this.getAllMonitorIndustryList();
    this.getMonitorThemeList();
    this.getAllMonitorThemeList();
  }
};
</script>

<style lang="scss" scoped>
  .focus-industry {
    padding-top: 10px;
    height: calc(100vh - 67px);
    width: 100%;
    background-color: #f7f8fc;
    &-content {
      &-left {
        margin-right: 10px;
        width: 595px;
        background-color: #ffffff;
        &-table {
          padding:0 24px;
        }
      } 
      &-right {
        width: 595px;
        background-color: #ffffff;
        &-table {
          padding:0 24px;
        }
      }
      .add-btn {
        margin: 26px 0 16px 24px;
        height: 26px;
        width: 108px;
        padding: 0;
        border-radius: 2px;
        border: none;
        font-size: 14px;
        color: #464d6c;
        background-color: #f7f8fc;
        font-weight: 400;
        &:hover {
          color: #464d6c;
          background-color: #eaebef;
        }
        &:focus {
          color: #464d6c;
          background-color: #eaebef;
        }
        &:active {
          color: #464d6c;
          background-color: #eaebef;
        }
      }
    }
  }
  .header-title {
    color: #747990;
    font-weight: 400;
  }
  .title-name {
    color: #464d6c;
    font-size: 14px;
  }
  .delete {
    display: inline-block;
    width: 16px;
    height: 16px;
    background-color: transparent;
    background-image: url("../../assets/img/delete-icon.svg");
    background-size: 100% 100%;
    cursor: pointer;
    &:hover {
      border-radius: 2px;
      background-image: url("../../assets/img/delete-icon-hover.svg");
    }
  }
  .delete-hover {
    height: 24px;
    padding: 3px 4px 5px 0px;
    &:hover {
      border-radius: 2px;
    }
    &:active {
      border-radius: 2px;
    }
    .delete {
      display: inline-block;
      width: 16px;
      height: 16px;
      background-color: transparent;
      background-image: url("../../assets/img/delete-icon.svg");
      background-size: 100% 100%;
      cursor: pointer;
      &:hover {
        border-radius: 2px;
        background-image: url("../../assets/img/delete-icon-hover.svg");
      }
    }
  }
  /deep/ {
    .el-table td,
    .el-table th.is-leaf {
      border-bottom: 1px solid #f7f7fa;
    }
    .el-table th.is-leaf {
      border-bottom: 1px solid #f7f7fa;
    }
    .el-table--enable-row-hover .el-table__body tr:hover > td {
      background-color: #f7f8fc !important;
    }
    .el-table::before {
      background-color: #f7f7fa;
    }
    .delete-dialog {
      .el-dialog {
        background-color: #ffffff;
        border-radius: 0;
        width: 400px;
        height: 229px;
        position: relative;
        .el-dialog__headerbtn {
          top: 14px;
        }
        .el-dialog__header {
          padding: 0;
          height: 44px;
          width: 100%;
          box-shadow: inset 0px -1px 0px 0px #f7f7fa;
          padding: 0 24px;
          .el-dialog__title {
            color: #171f46;
            font-size: 14px;
            line-height: 44px;
          }
        }
        .el-dialog__body {
          padding: 24px;
          margin-top: 44px;
          color: #747990;
          font-size: 14px;
          line-height: 22px;
        }
        .el-dialog__footer {
          width: 100%;
          height: 64px;
          background-color: #ffffff;
          box-shadow: inset 0px 1px 0px 0px #f7f7fa;
          position: absolute;
          bottom: 0;
          left: 0;
          padding: 16px 0;
          .footer-btn {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 136px;
            height: 32px;
            .cancel-btn {
              height: 32px;
              width: 60px;
              padding: 0;
              font-size: 14px;
              color: #464d6c;
              background-color: #f7f8fc;
              border-radius: 2px;
              border: none;
              &:hover {
                color: #464d6c;
                background-color: #eaebef;
              }
              &:focus {
                color: #464d6c;
                background-color: #eaebef;
              }
              &:active {
                color: #464d6c;
                background-color: #eaebef;
              }
            }
            .confirm-btn {
              height: 32px;
              width: 60px;
              padding: 0;
              font-size: 14px;
              color: #ffffff;
              background-color: #45a8cc;
              margin-left: 16px;
              border-radius: 2px;
              border: none;
              &:hover {
                color: #ffffff;
                background-color: #3e97b8;
              }
              &:focus {
                color: #ffffff;
                background-color: #3e97b8;
              }
              &:active {
                color: #ffffff;
                background-color: #3e97b8;
              }
            }
          }
        }
      }
    }
  }
  /deep/.filter-dialog {
  .dialog-selected-title {
    padding: 16px 24px 10px;
    color: #171f46;
    font-size: 14px;
  }
  .dialog-selected {
    padding: 0 24px 6px;
    width: 100%;
    max-height: 88px;
    overflow: auto;
    box-shadow: inset 0px -1px 0px 0px#f7f7fa;
    .selected-tag {
      flex-wrap: wrap;
      .industry-tag {
        margin-right: 10px;
        margin-top: 10px;
        padding: 4px 8px;
        border-radius: 2px;
        border: solid 1px #45a8cc;
        color: #45a8cc;
        font-size: 12px;
        .del-img {
          margin-left: 4px;
          margin-top: 2px;
          width: 16px;
          height: 16px;
          background: url("../../assets/img/del-img.svg") no-repeat;
          background-size: cover; 
          cursor: pointer;
        }
      }
    }
  }
  .dialog-content {
    padding: 16px 24px;
    width: 100%;
    height: 248px;
    box-shadow: inset 0px -1px 0px 0px#f7f7fa;
    .dialog-detail {
      flex-wrap: wrap;
      .dialog-detail-item {
        padding: 4px 8px;
        margin: 0 10px 10px 0;
        border-radius: 2px;
        border: 1px solid #e8e8e8;
        color: #464d6c;
        font-size: 12px;
        background-color: #ffffff;
        cursor: pointer;
      }
      .industry-active {
        border: 1px solid #45a8cc;
        color: #45a8cc;
      }
    }
  }
  .dialog-footer {
    width: 100%;
    height: 64px;
    .footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 64px;
      .footer-btn {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 130px;
        height: 32px;
        .cancel-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          font-size: 14px;
          color: #464d6c;
          background-color: #f7f8fc;
          border-radius: 2px;
          border: none;
          &:hover {
            color: #464d6c;
            background-color: #eaebef;
          }
          &:focus {
            color: #464d6c;
            background-color: #eaebef;
          }
          &:active {
            color: #464d6c;
            background-color: #eaebef;
          }
        }
        .confirm-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          font-size: 14px;
          color: #ffffff;
          background-color: #45a8cc;
          border-radius: 2px;
          border: none;
          font-weight: 500;
          &:hover {
            color: #ffffff;
            background-color: #3e97b8;
          }
          &:focus {
            color: #ffffff;
            background-color: #3e97b8;
          }
          &:active {
            color: #ffffff;
            background-color: #3e97b8;
          }
        }
      }
    }
  }
  .el-dialog {
    background-color: #ffffff;
    box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
    border: solid 1px #f7f7fa;
    border-radius: 0;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      min-height: 290px;
      padding: 0;
    }
    .el-dialog__footer {
      padding: 0px;
    }
  }
}

  /deep/.theme-filter-dialog {
  .theme-dialog-selected-title {
    padding: 16px 24px 10px;
    color: #171f46;
    font-size: 14px;
  }
  .theme-dialog-selected {
    padding: 0 24px 6px;
    width: 100%;
    max-height: 88px;
    overflow: auto;
    box-shadow: inset 0px -1px 0px 0px#f7f7fa;
    .selected-tag {
      flex-wrap: wrap;
      .industry-tag {
        margin-right: 10px;
        margin-bottom: 10px;
        padding: 4px 8px;
        border-radius: 2px;
        border: solid 1px #45a8cc;
        color: #45a8cc;
        font-size: 12px;
        .del-img {
          margin-left: 4px;
          margin-top: 2px;
          width: 16px;
          height: 16px;
          background: url("../../assets/img/del-img.svg") no-repeat;
          background-size: cover; 
          cursor: pointer;
        }
      }
    }
  }
  .dialog-content {
    padding: 16px 0 16px 24px;
    width: 100%;
    height:260px;
    box-shadow: inset 0px -1px 0px 0px#f7f7fa;
    .input-container {
      position: relative;
      width: 217px;
      margin-bottom: 10px;
      input {
        width: 100%;
        height: 26px;
        margin-top: -6px;
        padding: 10px 50px 10px 12px;
        font-size: 14px;
        border: solid 2px #f7f8fc;
        border-radius: 2px;
        background-color: #f7f8fc;
        outline: none;
      }
      input::-webkit-input-placeholder{
        color: #9ea1b4;
      }
      input::-moz-placeholder{   /* Mozilla Firefox 19+ */
        color: #9ea1b4;
      }
      input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
        color: #9ea1b4;
      }
      input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
        color: #9ea1b4;
      }

      .search-button { 
        position: absolute;
        top: 3px;
        right: 2px;;     
        padding: 0px 12px;
        width: 46px;
        background-color: #f7f8fc;
        border: none;
        cursor: auto;
        span {
          display: block;
        }

        .icon-search {
          display: inline-block;
          width: 14px;
          height: 14px;
          background-image: url('../../assets/img/search3.svg');
          background-size: 100% 100%;
        }
      }
    } 
    .dialog-detail {
      overflow: auto;
      height: 200px;
      flex-wrap: wrap;
      .dialog-detail-item {
        height: 27px;
        padding: 4px 8px;
        margin: 0 10px 10px 0;
        border-radius: 2px;
        border: 1px solid #e8e8e8;
        color: #464d6c;
        font-size: 12px;
        background-color: #ffffff;
        cursor: pointer;
      }
      .industry-active {
        border: 1px solid #45a8cc;
        color: #45a8cc;
      }
    }
  }
  .dialog-footer {
    width: 100%;
    height: 64px;
    .footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 64px;
      .footer-btn {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 130px;
        height: 32px;
        .cancel-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          font-size: 14px;
          color: #464d6c;
          background-color: #f7f8fc;
          border-radius: 2px;
          border: none;
          &:hover {
            color: #464d6c;
            background-color: #eaebef;
          }
          &:focus {
            color: #464d6c;
            background-color: #eaebef;
          }
          &:active {
            color: #464d6c;
            background-color: #eaebef;
          }
        }
        .confirm-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          font-size: 14px;
          color: #ffffff;
          background-color: #45a8cc;
          border-radius: 2px;
          border: none;
          font-weight: 500;
          &:hover {
            color: #ffffff;
            background-color: #3e97b8;
          }
          &:focus {
            color: #ffffff;
            background-color: #3e97b8;
          }
          &:active {
            color: #ffffff;
            background-color: #3e97b8;
          }
        }
      }
    }
  }
  .el-dialog {
    background-color: #ffffff;
    box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
    border: solid 1px #f7f7fa;
    border-radius: 0;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      min-height: 290px;
      padding: 0;
    }
    .el-dialog__footer {
      padding: 0px;
    }
  }
}
.pager {
  display: flex;
  justify-content: center;
  height: 46px;
  margin-top: 26px;
  & /deep/ {
    .el-pagination{
      .btn-prev,
      .btn-next,
      .el-pager .number,
      .el-pager li.btn-quicknext,
      .el-pager li.btn-quickprev,
      .el-icon-more .el-icon-d-arrow-right{
        border-radius:2px;
        border:1px solid rgba(229,230,238,1);
        background: #ffffff;
        min-width: 22px !important;
        height: 22px;
        line-height: 22px;
        font-size: 12px;
      }
      .active{
        border: none;
      }
      .more::before {
        line-height: 22px;
      }
      .el-pagination__jump{
        color: #747990;
        line-height: 22px;
      }
    }
    .el-pagination__editor.el-input .el-input__inner {
      height: 22px;
    }
  }
}
</style>
